//
// client-mgmt-select-object.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/* jshint devel: true */
/* global angular: false, _: false */

// This is a helper object for populating selections for client-mgmt
const ClientMgmtSelectObject = function (ClientMgmtApiService, ClientMgmtPageState, name) {
    const that = this;

    // For errors and logging
    this.name = name;

    // If set, make the originalItem and selectedItem set to this value on population
    this.defaultItem = null;

    // If set, add this value to the populated items. It indicates a new value should be created to the user
    this.createNewIndicator = null;

    // To determine when the selection has changed from initial value. Also can be used to give to server
    // in case it requires the current value be given when changing it to a new value
    this.originalItem = null;

    // The current selected item
    this.selectedItem = null;

    // All of the items by name
    this.itemNames = [];

    // Map of ids to item names
    this.map = {};

    this.findIdForItem = function (name) {
        return this.map[name];
    };

    this.setDefault = function (name) {
        this.defaultItem = name;
    };

    this.setCreateNewIndicator = function (createNewIndicator) {
        this.createNewIndicator = createNewIndicator;
    };

    this.isCreateNewIndicatorSelected = function () {
        return this.getSelected() === this.createNewIndicator;
    };

    this.getOriginal = function () {
        return this.originalItem;
    };

    this.getOriginalId = function () {
        return this.findIdForItem(this.originalItem);
    };

    this.setOriginal = function (name) {
        this.originalItem = name;
    };

    this.getSelected = function () {
        return this.selectedItem;
    };

    this.getSelectedId = function () {
        return this.findIdForItem(this.selectedItem);
    };

    this.setInitialSelected = function (name) {
        this.setOriginal(name);
        this.selectedItem = name;

        // Allow for an item that was not populated to be set.
        // This item will not have a corresponding id in the map
        if (this.itemNames.indexOf(name) === -1) {
            this.itemNames.push(name);
        }
    };

    this.setOriginalToSelected = function (name) {
        this.setOriginal(this.selectedItem);
    };

    this.isDirty = function () {
        return this.getOriginal() !== this.getSelected();
    };

    const populateInternal = details => {
        that.itemNames = [];
        that.map = {};

        _.each(details, element => {
            if (element.hasOwnProperty('name') && element.hasOwnProperty('id')) {
                // Add item by name
                that.itemNames.push(element.name);

                // Add in mapping from name->id - if duplicates exist, take the first one seen
                if (!that.map[element.name]) {
                    that.map[element.name] = element.id;
                }
            } else {
                ClientMgmtPageState.setError(`Invalid elements in ${that.name}`);
                return;
            }
        });

        if (that.itemNames.length !== 0) {
            that.itemNames.sort();

            /* Add custom indicator to indicate a new selection can be created */
            if (that.createNewIndicator !== null) {
                that.itemNames.unshift(that.createNewIndicator);
            }

            /* If set, select the default */
            let defaultIndex = that.itemNames.indexOf(that.defaultItem);
            if (defaultIndex === -1) {
                defaultIndex = 0;
            }
            that.setInitialSelected(that.itemNames[defaultIndex]);
        } else {
            ClientMgmtPageState.setError(`Could not find any ${that.name}`);
        }
    };

    const populateError = err => {
        ClientMgmtPageState.setError(`Error getting initial ${that.name}: ${err}`);
    };

    this.populate = apiFunc => {
        apiFunc().then(populateInternal).catch(populateError);
    };

    this.populateFromMap = details => {
        populateInternal(details);
    };
};
